/**
 * Global JS
 */

// Vendors
import styles from '../scss/global.scss';
import $ from 'jquery';
import './lib/bootstrap';
import 'slick-carousel';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.scrollto/jquery.scrollTo.min';
import 'jquery.localscroll/jquery.localScroll.min';
import 'waypoints/lib/jquery.waypoints.min';
import './lib/wl-sticky';
import './lib/wl-share';

// Components
import './components/back-to-top';
import './components/nav-mobile';
import './components/nav-sidebar';
import './components/notice';
import './components/sidebar';
import './components/utilities';

// Init tweets carousel
$('.tweets').slick({
  autoplay: false,
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
  fade: true,
  cssEase: 'linear',
  prevArrow: '.tweet-prev',
  nextArrow: '.tweet-next'
});

$('input:checkbox').on('click', function() {
  // in the handler, 'this' refers to the box clicked on
  var $box = $(this);
  if ($box.is(':checked')) {
    $('.checkbox input:checkbox').prop('checked', false);
    $box.prop('checked', true);
  } else {
    $box.prop('checked', false);
  }
});



// WEBPACK FOOTER //
// ./assets/js/global.js